// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3k0bJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gsap = require("gsap");
var _scrollTrigger = require("gsap/dist/ScrollTrigger");
(0, _gsap.gsap).registerPlugin((0, _scrollTrigger.ScrollTrigger));
/**
 * Text Reveal Effect for Section 3 - Right Column
 * Splits text into words and animates opacity on scroll
 * Similar to CRED's "Not everyone makes it in" section
 */ class TextReveal {
    constructor(){
        this.init();
    }
    init() {
        // Wait for both DOM and window load, plus smooth scroll initialization
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
            window.addEventListener('load', ()=>{
                // Wait for smooth scroll to initialize
                setTimeout(()=>this.setup(), 800);
            });
        });
        else if (document.readyState === 'interactive') window.addEventListener('load', ()=>{
            setTimeout(()=>this.setup(), 800);
        });
        else // Page already loaded, setup with delay for smooth scroll
        setTimeout(()=>this.setup(), 800);
    }
    setup() {
        // Select all paragraphs in the enterprise-right column
        const paragraphs = document.querySelectorAll('.enterprise-right .body-default');
        if (paragraphs.length === 0) {
            setTimeout(()=>this.setup(), 1000);
            return;
        }
        // Process all paragraphs and collect all word spans
        const allWordSpans = [];
        paragraphs.forEach((paragraph, index)=>{
            const words = this.splitIntoWords(paragraph.innerHTML);
            // Replace paragraph content with wrapped words
            const wrappedHTML = words.map((word, wordIndex)=>{
                if (word.trim().startsWith('<img')) return `<span class="text-reveal-word" style="opacity: 0.25;">${word}</span>`;
                return `<span class="text-reveal-word" style="opacity: 0.25;">${word}</span>`;
            }).join(' ');
            paragraph.innerHTML = wrappedHTML;
            // Collect word spans from this paragraph
            const wordSpans = paragraph.querySelectorAll('.text-reveal-word');
            allWordSpans.push(...Array.from(wordSpans));
        });
        if (allWordSpans.length === 0) return;
        // Make only the first 8 words across ALL paragraphs white
        const initialWhiteWords = Math.min(8, allWordSpans.length);
        allWordSpans.slice(0, initialWhiteWords).forEach((span)=>{
            span.style.opacity = '1';
        });
        // Create individual ScrollTriggers for each word to maintain consistent reveal position
        allWordSpans.forEach((word, index)=>{
            // Skip the first few words that are already white
            if (index < initialWhiteWords) return;
            (0, _gsap.gsap).to(word, {
                opacity: 1,
                ease: 'none',
                scrollTrigger: {
                    trigger: word,
                    start: 'top 62%',
                    end: 'top 58%',
                    scrub: 0.2,
                    markers: false
                }
            });
        });
        // Refresh ScrollTrigger to recalculate positions
        (0, _scrollTrigger.ScrollTrigger).refresh();
    }
    splitIntoWords(html) {
        // Create a temporary div to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const words = [];
        const nodes = Array.from(tempDiv.childNodes);
        nodes.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) {
                // Split text nodes into words
                const textWords = node.textContent.split(/(\s+)/);
                words.push(...textWords.filter((w)=>w.trim().length > 0 || w === ' '));
            } else if (node.nodeType === Node.ELEMENT_NODE) // Keep element nodes (like img tags) intact
            words.push(node.outerHTML);
        });
        return words;
    }
    // Clean up ScrollTrigger instances
    destroy() {
        (0, _scrollTrigger.ScrollTrigger).getAll().forEach((trigger)=>trigger.kill());
    }
    // Refresh ScrollTrigger (useful for dynamic content)
    refresh() {
        (0, _scrollTrigger.ScrollTrigger).refresh();
    }
}
// Initialize the text reveal effect
const textReveal = new TextReveal();
// Expose for debugging
window.textReveal = textReveal;
// Export for external use
exports.default = textReveal;

},{"gsap":"kKW9v","gsap/dist/ScrollTrigger":"jusUN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["3k0bJ"], "3k0bJ", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.04735449.js.map
